module.exports = __webpack_public_path__ + "static/media/edit.e9a2496b.svg";